import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { reduxForm } from "redux-form";
import { get } from "lodash";

import Dialog from "./DialogWrap";

import {
  deleteOrganizationUserBinding,
  getOrganizationUsersAdmin,
  getOrganizationUsersOwner,
  getOrganizationUsersUser
} from "../../actions/resourceActions";

const DeleteOrganizationUserBinding = ({ handleSubmit, data }) => (
  <Dialog
    title="Odstranit provází uživatele"
    name="DeleteOrganizationUserBinding"
    handleSubmit={handleSubmit}
    submitLabel="Odstranit"
  >
    <p>
      Opravdu chcete odstranit provázání uživatele{get(data, "name") ? ` ${data.name}` : ""}?
    </p>
  </Dialog>
);

export default compose(
  connect(
    ({ dialog: { data } }) => ({
      data
    }),
    {
      deleteOrganizationUserBinding,
      getOrganizationUsersAdmin,
      getOrganizationUsersOwner,
      getOrganizationUsersUser
    }
  ),
  withHandlers({
    onSubmit: dialog => async (formData, dispatch, props) => {
      const {
        deleteOrganizationUserBinding,
        data,
        getOrganizationUsersAdmin,
        getOrganizationUsersOwner,
        getOrganizationUsersUser
      } = props;

      let atollonEmailUserIdAsString = data.name;
      if (
        await deleteOrganizationUserBinding(data.organizationId, atollonEmailUserIdAsString)
      ) {
        getOrganizationUsersAdmin(data.organizationId);
        getOrganizationUsersOwner(data.organizationId);
        getOrganizationUsersUser(data.organizationId);
        dialog.closeDialog();
      }
    }
  }),
  reduxForm({
    form: "DeleteOrganizationUserBindingForm"
  })
)(DeleteOrganizationUserBinding);



// WEBPACK FOOTER //
// ./src/components/dialogs/DeleteOrganizationUserBinding.js